import type { Token, Tokens } from 'marked';

export const ISO_DATE_TOKEN_NAME = 'iso_date';

export interface IsoDateToken extends Tokens.Generic {
  type: typeof ISO_DATE_TOKEN_NAME;
  raw: string;
  text: string;
  isoString: string;
}

export function isIsoDateToken(token: Token): token is IsoDateToken {
  if (token.type !== ISO_DATE_TOKEN_NAME) {
    return false;
  }

  return 'isoString' in token;
}
